import { render, staticRenderFns } from "./edit-email.vue?vue&type=template&id=3accf61b&scoped=true&"
import script from "./edit-email.vue?vue&type=script&lang=js&"
export * from "./edit-email.vue?vue&type=script&lang=js&"
import style0 from "./edit-email.vue?vue&type=style&index=0&id=3accf61b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3accf61b",
  null
  
)

export default component.exports